import React from "react";
import {
  DataGrid,
  DataGridProps,
  GridColDef,
  GridSlotsComponent,
  GridSlotsComponentsProps,
} from "@material-ui/data-grid";

import classes from "./BaseDataGrid.module.scss";

export type DataGridRowType<T extends { field: string }[]> = Record<T[number]["field"], any>;

type BaseDataGridProps<T extends GridColDef[]> = {
  columns: T;
  rows: DataGridRowType<T>[];
  components?: GridSlotsComponent;
  componentsProps?: GridSlotsComponentsProps;
  autoHeight?: boolean;
};

const BaseDataGrid = <T extends GridColDef[]>({
  columns,
  rows,
  components,
  componentsProps,
  autoHeight,
  ...rest
}: BaseDataGridProps<T> & DataGridProps) => {
  return (
    <div className={classes.container}>
      {components ? (
        <DataGrid
          autoHeight={!!autoHeight}
          components={components}
          componentsProps={componentsProps}
          columns={columns}
          rows={rows}
          isRowSelectable={() => false}
          {...rest}
        />
      ) : (
        <DataGrid autoHeight={!!autoHeight} columns={columns} rows={rows} isRowSelectable={() => false} {...rest} />
      )}
    </div>
  );
};

export default BaseDataGrid;
